import React, { InputHTMLAttributes } from 'react';

import { DefaultProps, FormatProps } from './types';
import { useField } from './useField';

type CheckboxProps = DefaultProps & FormatProps & InputHTMLAttributes<unknown>;

export const RxCheckbox: React.FC<CheckboxProps> = React.memo((props) => {
    const { rest, onInputChange, onInputBlur, ref } = useField(props);
    return (
        <input
            {...rest}
            ref={ref as any}
            name={props.field}
            onChange={onInputChange}
            onBlur={onInputBlur}
            type="checkbox"
        />
    );
});

export const Checkbox = RxCheckbox;
